import Header from "./components/Header";
import Main from "./components/Main";
import Footer from "./components/Footer";
import Browse from "./components/Browse";
import Detail from "./components/CardDetails";
import SignUp from "./components/SignUp";
import SignIn from "./components/LogIn";
import AddProperty from "./components/AddProperty";

import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";

function App() {
  return (
    <ChakraProvider>
      <Router>
        <Header />
        <Switch>
          <Route path="/property/addproperty">
            <AddProperty />
          </Route>
          <Route path="/signup">
            <SignUp />
          </Route>
          <Route path="/signin">
            <SignIn />
          </Route>
          <Route path="/property/details/:id">
            <Detail />
          </Route>
          <Route path="/browse">
            <Browse />
          </Route>
          <Route path="/">
            <Main />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </ChakraProvider>
  );
}

export default App;
